/* eslint-disable react/jsx-filename-extension */
/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { CookiesProvider } from 'react-cookie';
import useEventWindowPopup from './src/hooks/useEventWindowPopup';
import useRedirectMobile from './src/hooks/useRedirectMobile';

const CommonWrapper = ({ children }) => {
  useRedirectMobile(['/EventWindowPopup/']);

  return <>{children}</>;
};

// eslint-disable-next-line import/prefer-default-export
export const wrapRootElement = ({ element }) => (
  <CookiesProvider>
    <CommonWrapper>
      <GoogleReCaptchaProvider reCaptchaKey={`${process.env.REACT_APP_RECAPTCHA_KEY}`}>
        {element}
      </GoogleReCaptchaProvider>
    </CommonWrapper>
  </CookiesProvider>
);
